import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
//Componentes
import CreditCard from "../CreditCard";
//Icons
import { Plus, Trash } from "@phosphor-icons/react";
//Utils
import { HandleSelectedPayment } from "utils/FunctionPayment";

interface ICreat {
  subtotal: number;
  totalWithDiscount: (total: number) => void;

  register: any,
  errors: any,
  reset: any,
  resetField: any,
  control: any,
  getValues: any
  watch: any,
}

interface IMethPay {
  id: number;
  form_payment: string;
}

export default function CombinedPayment({
  subtotal,
  totalWithDiscount,
  register,
  errors,
  reset,
  resetField,
  control,
  getValues,
  watch
}: ICreat) {
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [paymentAmount, setPaymentAmount] = useState<number[]>([1]);
  const [formPaymentSelecByIndex, setFormPaymentSelecByIndex] = useState<{ [key: number]: string }>({});

  const discount = watch('discount') || 0;

  const addPayment = () => {
    setPaymentAmount([...paymentAmount, paymentAmount.length + 1]);
  };

  const removePayment = (indexToRemove: number) => {
    if (paymentAmount.length > 1) {
      // Atualizar o array de pagamentos
      const updatedPayments = paymentAmount.filter((_, index) => index !== indexToRemove);
      setPaymentAmount(updatedPayments);

      // Obter os valores atuais do formulário
      const currentValues = getValues();

      // Verificar se os arrays existem antes de aplicar o filtro
      const updatedFormPaymentId = Array.isArray(currentValues.form_payment_id)
        ? currentValues.form_payment_id.filter((_: any, index: number) => index !== indexToRemove)
        : [];
      const updatedAmount = Array.isArray(currentValues.amount)
        ? currentValues.amount.filter((_: any, index: number) => index !== indexToRemove)
        : [];
      const updatedCardId = Array.isArray(currentValues.card_id)
        ? currentValues.card_id.filter((_: any, index: number) => index !== indexToRemove)
        : [];

      // Atualizar os campos com os valores filtrados
      reset({
        ...currentValues,
        form_payment_id: updatedFormPaymentId,
        amount: updatedAmount,
        card_id: updatedCardId,
      });
    }
  };

  const ModalSelectedPayment = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const result = HandleSelectedPayment(event);

    if (typeof result === 'object') {
      const { id, name } = result;

      setFormPaymentSelecByIndex((prev) => ({
        ...prev,
        [index]: name,
      }));
    } else {
      console.log('Nenhum pagamento selecionado.');
    }
  }

  const result = subtotal - (subtotal * discount / 100);
  totalWithDiscount(result);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("form-payment");
        const paymentData = response.data;
        console.log(paymentData);

        setFormPay(paymentData);

      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <S.Container>
      <S.Content>
        {paymentAmount.map((paymentIndex, index) => (
          <S.ContentPayment key={paymentIndex}>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label htmlFor="qtd_installment">
                  Forma de Pagamento <span>*</span>
                </S.Label>
                <S.Select
                  id={`form_payment_id.${index}`}
                  {...register(`form_payment_id.${index}`, { required: true })}
                  onChange={(e) => ModalSelectedPayment(e, index)}
                >
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {formPay.map((val) => {
                    const value = val.id;

                    return (
                      <option key={value} value={value}>
                        {val.form_payment}
                      </option>
                    );
                  })}
                </S.Select>
                {errors[`form_payment_id.${index}`] && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label htmlFor={`amount.${index}`}>
                  Valor <span>*</span>
                </S.Label>
                <Controller
                  name={`amount.${index}`}
                  rules={{ required: "Campo Obrigatório" }}
                  control={control}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      className="InputDiscout"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors[`amount.${index}`] && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>

            {formPaymentSelecByIndex[index] === "credit-card" && (
              <CreditCard
                index={index}
                register={register}
                errors={errors}
                reset={reset}
                resetField={resetField}
                subtotal={watch(`amount.${index}`) || 0}
              />
            )}

            {paymentAmount.length > 1 && (
              <S.ContentButton>
                <S.ButtonRemove onClick={() => removePayment(index)}>
                  <Trash />
                  Remover
                </S.ButtonRemove>
              </S.ContentButton>
            )}
          </S.ContentPayment>
        ))}
      </S.Content>

      <S.ContentButton>
        <S.Button onClick={addPayment}>
          <Plus size={16} />
          Pagamento
        </S.Button>
      </S.ContentButton>
    </S.Container>
  );
}
